var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#19b6ef",
    fillRule: "evenodd",
    d: "M0 20h53.3v20H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 0h53.3v20H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fd0",
    fillRule: "evenodd",
    stroke: "#7d6c00",
    strokeWidth: 0.3,
    d: "M26.4 28.3c4.4-3.3 9.1-10 3.6-13.5-1-.2-2.2-.1-2.7.3q-.5-.3-.9.2-.2-.5-.8-.3a3 3 0 0 0-2.6-.2c-4.8 2.8-1.9 9.7 3.4 13.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4fd46b",
    fillRule: "evenodd",
    stroke: "#3a9d4f",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    d: "m34.5 20.8.5-.6q.7-.6.6-.7.4-.3.3-.6l.1-.6s.2-.7 0-.8q-.1-.9-.8-.1-.4.1-.3.7c-.4 0-.4.6-.3 1-.6 0-.3.7-.3.7-.2.1.2 1 .2 1Zm-3.8 5.7.3.2q0 .4.4.4.2.5.8 0 .3.5.8.3.6.3 1.1-.1.4.2.7-.2.3 0 .5-.3.6-.2-.1-.7c.3-.2.6-.8.1-.9h-.6q-.1-.4-.8 0-.3-.3-.8 0-.4-.3-1 .1zm0-.7q-.2-.6.1-1-.2-.9.7-1-.2-.9.6-1s.5-1.6 1-.5q.1.6-.3.8.1.6-.5.7.3.5 0 .8zm2.7-2h.5q.6-.7 1-.2.7 0 .8.3.6.1.4.6c.1.4 0 1-.4.3-1-.6-1.5-.5-3-.1zm.3-.5s1.4-.4 1.3-.8c.4 0 .5-.5.5-.5q1-.6.8-.7c.2-.3.7-.6.6-1q.2-1-.7-.5-.7 0-.8.7-.6-.3-.7.6l-.7.6-.5 1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4fd46b",
    fillRule: "evenodd",
    stroke: "#3a9d4f",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    d: "M33.7 22.2q-.5-.5-.5-.9-.4-.4-.1-.7l-.2-.7q-.6-.3-.1-.6-.4-.5 0-1c0-.5.3-.2.6 0 0 0 .6.5.2.8q.6.3.3.6.4.4.2.7.3.4.3.9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4fd46b",
    fillRule: "evenodd",
    stroke: "#3a9d4f",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    d: "M34.3 19.7s-.6-.8-.4-.8l-.1-.7q-.4-.5 0-.8-.4-.5 0-.9.1-.5.5-.6.4-.8.7 0 .4.4.2 1c.3.1 0 .4 0 .5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4fd46b",
    fillRule: "evenodd",
    stroke: "#3a9d4f",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    d: "m34.2 16-.4-.4c0-.2.2-.7-.2-.9-.2-.5-1.2-1-1.3 0q-.4-.6-.7-.2-.8-.6-.5.3s-.3.3.3.6c.1 0-.2.7.6.7q-.2.4.4.5-.2.5.4.4-.2.5.3.5l.4.5.4.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3a9d4f",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    d: "M34.5 20.5s1-2 1-2.6m-.9-1s.2 1.7-.2 2.9m-2.5-4.6s1.8 1.8 2 2.5m-.7-2.6s0 1.4.6 2.8m2.6 2.4s-1.9 1.5-2.7 2.9m1 2.5-3.5.3m2.7.7s-3 0-3.2-.3m1.7-3.6s-1.5 2.6-1.6 3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#65c7ff",
    fillRule: "evenodd",
    stroke: "#7d6c00",
    strokeWidth: 0.3,
    d: "M26.4 27.8c-3.1-3-6.4-8.5-3.2-11.4.6.4 1.3 0 2.2-.3q.4.5 1 .1a1 1 0 0 0 .9-.1q1.7.9 2.3.3c3.2 3 0 8.6-3.2 11.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8fc753",
    fillRule: "evenodd",
    d: "M26.4 27.7q-2.1-2.1-3.5-4.8.2-.1.3-.4h1.4q0 .6.4 1.2l.7-1.2H27c.2.3.1.9.6 1.3.3-.9.6-.9.8-1.4q.6.2 1 0l.5.5q-1.3 2.7-3.6 4.8",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m22.7 13.7-.3.3-.2-.3a.3.3 0 0 1 .5 0Zm-.3-.6a.3.3 0 1 1-.5 0 .3.3 0 0 1 .5 0Zm-.3-.6a.3.3 0 1 1-.6 0 .3.3 0 0 1 .6 0Zm-.2-.6a.3.3 0 1 1-.6 0 .3.3 0 0 1 .6 0Zm0-.7a.3.3 0 1 1-.6.1.3.3 0 0 1 .6 0Zm1.5-1-.3.3a.3.3 0 0 1-.2-.5.3.3 0 0 1 .5.2Zm-.6.1-.3.3a.3.3 0 0 1-.1-.5.3.3 0 0 1 .4.2Zm-.6.4a.3.3 0 0 1-.4.3l-.2-.3a.3.3 0 0 1 .6 0Zm1.9-.5-.2.3a.3.3 0 1 1 .2-.3Zm.8 0a.3.3 0 1 1-.6.2.3.3 0 0 1 .6-.1Zm.6 0a.3.3 0 0 1-.5.3v-.3a.3.3 0 0 1 .5 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fd0",
    fillRule: "evenodd",
    stroke: "#7d6c00",
    strokeWidth: 0.1,
    d: "M27.2 9.8a.7.7 0 1 1-1.5 0 .7.7 0 0 1 1.5 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M28 10.2a.3.3 0 1 1-.7 0 .3.3 0 0 1 .6 0Zm.6 0a.3.3 0 0 1-.4.4l-.1-.3a.3.3 0 0 1 .5 0Zm.7 0a.3.3 0 0 1-.2.4.3.3 0 0 1-.2-.5.3.3 0 0 1 .4.2Zm.6 0a.3.3 0 1 1-.5.1.3.3 0 0 1 .5 0Zm.8.1a.3.3 0 0 1-.4.3.3.3 0 1 1 .4-.3Zm.6.4a.3.3 0 1 1-.6 0 .3.3 0 0 1 .6 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e40000",
    fillRule: "evenodd",
    stroke: "#ac0000",
    strokeWidth: 0.3,
    d: "m22.4 12.6.8 1.4h6.6l.7-1.3q-.5-.5-1.4-.4-.4-.7-1.3-.6l-.6-.3h-1.4q-.6.2-.7.4-1-.3-1.2.5-.8-.2-1.5.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M31.5 11.3a.3.3 0 1 1-.6 0 .3.3 0 0 1 .6 0Zm0 .6a.3.3 0 1 1-.5.1.3.3 0 0 1 .5 0Zm-.2.6a.3.3 0 0 1-.2.4.3.3 0 1 1 .2-.4Zm-.2.5a.3.3 0 1 1-.6 0 .3.3 0 0 1 .6 0Zm-.3.7a.3.3 0 1 1-.6 0 .3.3 0 0 1 .6 0Zm-4-.8a.4.4 0 1 1-.8 0 .4.4 0 0 1 .9 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27 12a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M26.9 11a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fd0",
    fillRule: "evenodd",
    stroke: "#7d6c00",
    strokeWidth: 0.1,
    d: "M26.3 9v-.3H26v-.2h.3v-.3h.3v.2h.3v.3h-.3v.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fd0",
    strokeWidth: 0.4,
    d: "M23.1 14c-.6-1-1.4-2.3-.9-3 .8-.8 2.5 0 3.6-.5.1 1-.2 2.5.3 2.8l-.4.4c-.3-.3-.7-.7-1.3 0q-.5-.4-.9.2zm6.7 0c.6-1 1.5-2.4 1-3-.8-.8-2.6 0-3.7-.6 0 1 .2 2.6-.2 3l.4.3q.6-.9 1.2 0 .6-.5 1 .1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fd0",
    fillRule: "evenodd",
    stroke: "#7d6c00",
    strokeWidth: 0.3,
    d: "M23.1 14.8q3.3-.3 6.6 0l.3-.8a19 19 0 0 0-7 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c76e2e",
    fillRule: "evenodd",
    d: "M26.2 27.5V27h.6l.2-.3-.1-.2-.3.2h-.4l-.2-.6q-.1-.2-.3.2v.2l.2.3v.3zm0-1.6-.5-.1H25l.3-.2q0-.4.2-.4h.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe100",
    fillRule: "evenodd",
    stroke: "#e9bf00",
    strokeWidth: 0.3,
    d: "M25 30.5c.6-1 4.7-2.9 8.6-7-4 3.8-6.4 4.7-9.6 7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9d4916",
    fillRule: "evenodd",
    stroke: "#68300e",
    strokeWidth: 0.1,
    d: "M30.7 26.1a.3.3 0 1 1-.6 0 .3.3 0 0 1 .6 0Zm2.9-3a.3.3 0 1 1-.6-.1.3.3 0 0 1 .6.2Zm1-2.4a.3.3 0 0 1-.4.4.3.3 0 0 1-.3-.4.3.3 0 0 1 .6 0Zm-1-3.2a.3.3 0 1 1-.6.1.3.3 0 0 1 .6 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#a9a9a9",
    strokeWidth: 0.1,
    d: "M23.3 22.5v-1.3l-.2-.1v-.3h.3v-1.4l-.1-.1V19h.1v-1l-.2-.2.2-.2v-.4l.3-.3h.8l.2.1v.6l-.2.1h-.3l.1.3v.7l-.1.1v.4h.3v.2h-.2v1.3l.3.1v.4h-.1v1.4zm5.2 0v-1.3h-.2v-.4h.3v-1.4l-.1-.1v-.2h.1v-1.2l-.2-.2.2-.1V17l.3-.3h.8l.2.1v.7h-.5l.1.3v.8h-.1v.4h.3v.2h-.2v1.4h.3v.4h-.1v1.4zm-2.7 0v-1.2l-.1-.1v-.3h.2V19l.1-.2v-.3l-.1-.3v-.9l.1-.3.2-.2.4-.1h.4l.3.2v.6h-.5V19h.3v.3h-.3v1.3h.4v.4l-.1.1v1.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M23.6 22.5v-1h.5v1zm2.6 0v-1h.5v1zm2.6 0v-1h.5v1zm-5-3h.2v.5h-.3zm2.4 0h.5v.5h-.5zm2.6 0h.4v.6h-.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a8a8a8",
    strokeWidth: 0.1,
    d: "m23.9 17.3.3.3m2.2-.4q0 .3.3.5m2.5-.4.2.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b97700",
    fillRule: "evenodd",
    d: "M23.5 16.2c1-.4-.2-1-.4 0q-.3.2-1 .2c-1.8 2.7-.5 7.2 4.4 11.8-8.8-7.6-5.2-13.2-2.8-13 1.3.1.7 1.8-.2 1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7d6c00",
    strokeWidth: 0.3,
    d: "M23.8 14.8s.8.2.8.5m0-.6s.6.2.7.5m3.8-.4s-.8 0-1 .3m-.1-.2s-.5.3-.4.4m.3 1s-.4-.4-.3-.8M25 16l.2-.6m1.1-.2v1m.8-.2s.3-.7 0-1m-1.7 0q-.2.1 0 1m1.6-.5-.5.2m-1-.1h.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c76e2e",
    fillRule: "evenodd",
    d: "m25 25.2.4-.2v-.4h-.3l-.4-.5v-.4q-.4.1-.5.5l.2.3h.3v.3q.3 0 .3.4m-.3-1.9v-.5h-.4l-.1.2h-.3l.3.4zm-1.1.8-.2-.4h.3zm3 .3.2-.3-.4-.4h-.3l-.3-.1.2.2zm.4 0h.5l.2-.5.5.6h-.4l-.2.3h-.7zm.2-1v-.6h-.5l-.4.1s.1.4.3.3q0 .3.3.2zm2.1-.5v.6h.3l.4-.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b97700",
    fillRule: "evenodd",
    d: "M29.4 16.1c-1-.3.3-1 .5 0 .3 0 .3.3 1 .2 1.7 2.7.5 7.2-4.5 11.8 8.9-7.5 5.3-13.1 2.8-13-1.3.2-.6 1.8.2 1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c76e2e",
    fillRule: "evenodd",
    d: "m29.5 23.7-.2.2-.4.1h-.3l-.1-.2.3-.3q-.4 0-.7.3l.2.4.3.3h.5zm-2 2.5c.2 0 1-1 1-1q0-.3-.4-.5l-.4.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006800",
    fillRule: "evenodd",
    stroke: "#004100",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    d: "M22.2 26.5q-1.8-1.9-5.2-1l1.8.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00a400",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    d: "M18.6 25.7c2.5 0 3.2.7 3 .6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006800",
    fillRule: "evenodd",
    stroke: "#004100",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    d: "M22.2 26.6c-.7.1-1.7.8-2 .8q-1.1-.2-2.3-.7h-1c2.8-1.3 3.7-1 5.3-.1Zm-1.8-1.9-1.3.1q-.6 0-1.6-1c-.4-.4-1.1-.4-1.1-.4q2.5-.6 4 1.3Zm-1.2-1.8a4 4 0 0 1-3.1-2.5l.3.3c2 .6 2.2 1 2.8 2.2Zm2 2.1q.5-1.6-.2-2.5-.6-.6-.9-1.5c0 1.4-.4 2.7 1.2 4Zm-1.9-3c1-1.4 1.1-2.4 1-4l-.4.9c-1.4.8-.8 2.2-.6 3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006800",
    fillRule: "evenodd",
    stroke: "#004100",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    d: "M18.5 15.4c1 1.4.8 2.6.6 4.2l-.3-.9c-1.4-.8-.5-2.4-.3-3.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006800",
    fillRule: "evenodd",
    stroke: "#004100",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    d: "M19.3 17.5c2.2-1.1 1.3-2.6 1.8-3.7a4 4 0 0 0-1.8 3.7Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00a400",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    d: "m19.6 17.2.9-2.1m-1.6 3.8-.3-2.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006800",
    fillRule: "evenodd",
    stroke: "#004100",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    d: "M19 21.4c-1.2-.1-2.6-1.8-3-3.1l.5.3c1.7.8 2 1.5 2.5 2.8Zm-.3-1.2c-1-1.3-1.1-2.3-1-4l.4 1c1.3.8.7 2.2.6 3Zm.8-2.3c2.3-1 1.6-2.1 2.3-3.3-1.6 1.2-2.3 2-2.3 3.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00a400",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    d: "M19.6 17.6q.8-.7 1.2-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe100",
    fillRule: "evenodd",
    stroke: "#e9bf00",
    strokeWidth: 0.3,
    d: "M27.8 30.5h1.1c-3.7-3.4-10.9-5-9.9-11.4-1 7 5.9 7.6 8.8 11.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9d4916",
    fillRule: "evenodd",
    stroke: "#68300e",
    strokeWidth: 0.1,
    d: "M19.6 17.7a.4.4 0 1 1-.7 0 .4.4 0 0 1 .7 0Zm-.2 2a.3.3 0 1 1-.6-.2.3.3 0 0 1 .6.2Zm.3 2.8a.3.3 0 1 1-.6 0 .3.3 0 0 1 .6 0Zm2.6 3.1a.3.3 0 1 1-.6 0 .3.3 0 0 1 .6 0Zm.4.9a.3.3 0 1 1-.6 0 .3.3 0 0 1 .6 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M24 29q-.3 0-.4-.4l-1.2-.1v.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M15.4 28.3c.7.1 1.7 0 2 .4.5.4-1.2 1.1-1 1.5.6.6 1.1.3 1.7 0l.3-1c-.2-.4-.8-.6-.6-1.4 1-.3 2.7-.3 3-.2v.7q-.4.5-.6 1.1c1 .4 1.3 0 2.2 0s1.6.3 1.9-.1c-.2-.4-1.1-.1-1.5-.3l-.5-.4c-.1-.2-.6-.2-.6-.6.2-.8 1.4-.7 1.6-.8l3.2.2c.6 0 .9 1 .1 1.3s-3-.4-4 .1c-.1-.2-.9-.6-1-.6l-.8.1-.5.7c-.7-.2-1.3.3-2 .1l-1.1.1h-.8l-1 .3.7-.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M15.4 28.2a.3.3 0 1 1-.6 0 .3.3 0 0 1 .6 0Zm0 1.5a.3.3 0 1 1-.6-.2.3.3 0 0 1 .5.2Zm13.5-.7q.2 0 .3-.4l1.2-.1v.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M37.4 28.3c-.7.1-1.7 0-2 .4s1.2 1.1 1 1.5q-.7.8-1.6 0l-.3-1c.2-.4.7-.6.6-1.4-1-.3-2.8-.3-3-.2v.7q.5.6.6 1.1c-1 .4-1.3 0-2.2 0s-1.7.3-2-.1c.2-.4 1.2-.1 1.6-.3l.4-.4q.4-.1.7-.6c-.2-.8-1.4-.7-1.6-.8l-3.2.2c-.6 0-1 1-.1 1.3.7.4 3-.4 4 .1.1-.2.8-.5.9-.6l.9.1.5.8c.6-.4 1.2.2 2 0l1.1.1h.7l1.1.3-.8-.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M37.5 28.2a.3.3 0 1 0 .6 0 .3.3 0 0 0-.6 0Zm0 1.5a.3.3 0 1 0 .7 0 .3.3 0 0 0-.6 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M26.4 27.4H26l-.5 1.3h1.3c-.4 0-.3-1.2-.3-1.3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M23.6 28.4v-1h.2v.8h.4v.2zm.7 0v-.9h.2v.9zm.7.1h-.3v-1h.3l.2.1v.4l.1.2v.2zm-.1-.8v.2l.2-.1zm0 .3v.3h.2V28zm.8-.2v.2h.3v.1h-.3v.3h.4v.1h-.5v-.9h.5v.2zm1.1.7-.2-.3h-.1v.3h-.2v-.9h.3q.3 0 .3.3v.1l-.1.1.2.4zm-.3-.7v.2h.2v-.2zm1 0v.7h-.2v-.7H27v-.2h.8v.1zm.9.6v-.2H28v.2h-.2l.3-1h.1l.4 1zm-.2-.6-.1.3h.2zm.5.5v-.1h.4V28h-.2l-.1-.1v-.1l-.1-.1v-.2h.5v.1h-.3l.1.2.2.1v.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00a400",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    d: "M19.3 26.6h2.5m-3.8-3c.7.6 2.3 1 2.2 1m1 .1-.8-2.2m-3.6-1.3c1.2.6 1.4 1 2.1 1.4m.5-1.1c0-1.5.3-1.9.6-2.2m-3.2-.2 1.9 2m-.6-3.3c.5.4.5 1.8.5 1.8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSm);
export default __webpack_public_path__ + "static/media/sm.4711cfaf5c6148dce4f76c43beb935b3.svg";
export { ForwardRef as ReactComponent };